<template>
  <base-modal :show-close="false" :center="true" :visible.sync="visible">
    <div class="wrapper">
      <h3 class="title">《隐私政策》更新提醒</h3>
      <div class="content">
        欢迎使用我们的服务。我们非常重视您对我们数字平台的使用，以及您的个人信息的安全与保护，并已更新了<a
            :href="userAgreement"
            target="_blank"
            class="privacy-link">《用户协议》
        </a>和<a
            :href="privacyLink"
            target="_blank"
            class="privacy-link">《隐私政策》
        </a>。请您点击链接了解具体内容，并仔细阅读。《用户协议》约定了您访问和使用我们数字平台的各项条款。《隐私政策》则向您说明我们收集的个人信息种类、处理方式和目的，以及您在个人信息处理过程中享有的权利。若您同意，请点击下方按钮开始接受我们的服务。
      </div>

      <div class="content">请注意，仅当触发特定场景时，我们才会收集您特定的个人信息；如未涉及相关场景，将不会进行该部分对应的信息收集。</div>
      <div class="btn-module">
        <button class="cancle" @click="submitAgree(false)">退出</button>
        <button class="is-agree" @click="submitAgree(true)">同意并继续</button>
      </div>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal'
const VUE_APP_PC=process.env.VUE_APP_PC
export default {
  name: "PrivacyModal",
  components: {BaseModal},
  props: {
    value: {
      type: Boolean,
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("update:value", val)
      }

    }
  },

  data() {
    return {
      privacyLink: `${VUE_APP_PC}/content/brand/legalinfo/privacy`,
      userAgreement:`${VUE_APP_PC}/content/brand/legalinfo/repeat`
    }
  },
  methods: {
    submitAgree(val) {
      this.$emit('submit', val);
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
}

.title {
  font-size: 28px;
  text-align: center;
  padding: 15px 15px 15px;
  color: #333333;
}

.content {
  text-indent: 2em;
  line-height: 28px;
  color: #333333;
  font-size: 20px;
}

.btn-module {
  padding: 25px 0;
  text-align: center;

  & > button {
    font-size: 16px;
    color: #333333;
    border: 1px solid #cccccc;
    background-color: #FFFFFF;
    padding: 5px 10px;
    border-radius: 5px;
    box-sizing: border-box;
    &.cancle{
      padding: 5px 48px;
    }

    &:hover {
      background-color: #F0F0F0;
    }

    &:active {
      background-color: #f7f7f7;
    }

    &.is-agree {
      margin-left: 20px;
      border: 1px solid #FBC500;
      background-color: #FBC500;

      &:hover {
        background-color: #daaa09;
      }

      &:active {
        background-color: #FBC500;
      }
    }
  }
}
</style>